import { render, staticRenderFns } from "./appliance-dish-edit.vue?vue&type=template&id=239bc96c&"
import script from "./appliance-dish-edit.vue?vue&type=script&lang=js&"
export * from "./appliance-dish-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports